import { takeEvery, call, put } from 'redux-saga/effects'
import { DELETE_SUBUSER, loading, loadSubusers } from '../../store/Roles/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(DELETE_SUBUSER, worker)
}

function* worker({ payload }) {
    yield put(loading(true))
    try {
        const subuser = yield call(deleteSubuser, { ...payload })
        if (subuser.error && subuser.error.length) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${DELETE_SUBUSER}.`, subuser],
                text: "При удалении пользователя произошла ошибка. Попробуйте перезагрузить страницу."
            }))
            // yield put(putSubusers([]))
        } else {
            yield put(loadSubusers())
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${DELETE_SUBUSER}.`, e],
            text: "При удалении пользователя произошла ошибка. Попробуйте перезагрузить страницу."
        }))
        // yield put(putSubusers([]))
    }
    finally {
        yield put(loading(false))
    }
}

function deleteSubuser(userdata) {
    let formData = new FormData()
    Object.keys(userdata).forEach(name => {
        formData.set(name, userdata[name])
    })
    return axios({
        url: "/account/subowner/delete",
        method: "POST",
        data: formData
    })
        .then(response => response.data)
}
